import { copyCodeToClipboard, openMessage } from "utils/misc";
import { generatePath } from "react-router-dom";
import { REGISTER_PATH } from "common/constants";
import i18n from "i18next";
import { ReferralType } from "types/affiliation.types";
import { toFixed } from "@shared/utils/numbers";
import { USD_PRECISION } from "features/affiliation/common/constants";

export const getReferralUrl = (referralCode: string | undefined) => {
  if (!referralCode?.length) referralCode = undefined;
  const originUrl = window.location.origin;
  const referralPath = generatePath(REGISTER_PATH, {
    referralCode,
  });
  return originUrl.concat(referralPath);
};

export const getReferralOrPromoCode = (
  referralCodes: string[] | string,
  referralType?: ReferralType
) => {
  if (referralType === ReferralType.PAYOUTS)
    return getReferralUrl(
      typeof referralCodes === "string" ? referralCodes : referralCodes[0]
    );
  return typeof referralCodes === "string"
    ? referralCodes
    : referralCodes.join(", ");
};

export const copyUrlToClipboard = (url: string) => {
  copyCodeToClipboard(url);
  openMessage(
    i18n.t("affiliation:messages.referral_link_copied", { value: url }),
    "info"
  );
};

export const copyCodeOrLinkToClipboard = (
  code: string,
  isReferralLink: boolean
) => {
  const value = isReferralLink ? getReferralUrl(code) : code;
  copyCodeToClipboard(value);
  openMessage(
    i18n.t(
      isReferralLink
        ? "affiliation:messages.referral_link_copied"
        : "affiliation:messages.promo_code_copied",
      { value }
    ),
    "info"
  );
};

export const getUsdValueWithPrecision = (value?: number) => {
  return `$${toFixed(value, USD_PRECISION)}`;
};
